import type { CommsMessage } from '../../interfaces/ICommsApi.js';

const PREVIEW_MAX_CHARS = 100;

/**
 * Derive the sidebar preview text from a message — mirrors the backend's
 * `buildLastMessagePreview` so the UI updates instantly without a refetch.
 */
export function derivePreviewText(message: CommsMessage): string {
  const text = message.segments
    .map((s) => (s.kind === 'text' ? s.text : `@${s.ref.label}`))
    .join('')
    .trim();
  if (text) return text.slice(0, PREVIEW_MAX_CHARS);
  if (message.attachments[0]) {
    const kind = message.attachments[0].kind;
    return kind === 'image' ? '[image]' : kind === 'voice' ? '[voice]' : '[file]';
  }
  return '';
}
